import { createAppAsyncThunk } from '@/redux/create-app-thunk';

export const sendLogs = createAppAsyncThunk(
  'logs/send',
  async (payload: SendLogsPayload, { getState, rejectWithValue, extra: { loggerService } }) => {
    const { message, url, data } = payload;
    const cartId = getState().cart.content.id;
    const storeId = getState().root.storeConf.storeId;
    const userId = getState().user.content?._id;
    const isTestEnv = getState().root.isTestEnv;
    try {
      if (isTestEnv) {
        return;
      }
      return await loggerService.sendLogV2({ cartId, storeId, userId, message, url, data });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type SendLogsPayload = {
  message: unknown;
  url: string;
  data: unknown;
}
